import { VStack } from '../VStack';
import type { VContextMenuGroupProps } from './type';

export const VContextMenuGroup = ({
  children,
}: React.PropsWithChildren<VContextMenuGroupProps>) => {
  return (
    <VStack aria-label="v-context-menu-group" role="group">
      {children}
    </VStack>
  );
};

VContextMenuGroup.displayName = 'VContextMenuGroup';
